
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/ui-components/PageTitle/PageTitle.vue';

@Component({
  name: 'ActionsCenterPage',
  components: {
    PageTitle
  },
})
export default class ActionsCenterPage extends Vue {
  
}
